var _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSiren(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.71593 1.8339C4.91812 1.6991 5.19131 1.75374 5.3261 1.95593L7.0861 4.59593C7.2209 4.79812 7.16626 5.07131 6.96407 5.2061C6.76188 5.3409 6.48869 5.28626 6.3539 5.08407L4.5939 2.44407C4.4591 2.24188 4.51374 1.96869 4.71593 1.8339Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2841 1.8339C19.0819 1.6991 18.8087 1.75374 18.6739 1.95593L16.9139 4.59593C16.7791 4.79812 16.8337 5.07131 17.0359 5.2061C17.2381 5.3409 17.5113 5.28626 17.6461 5.08407L19.4061 2.44407C19.5409 2.24188 19.4863 1.96869 19.2841 1.8339Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0C12.243 0 12.44 0.196995 12.44 0.44V3.96C12.44 4.20301 12.243 4.4 12 4.4C11.757 4.4 11.56 4.20301 11.56 3.96V0.44C11.56 0.196995 11.757 0 12 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 8.8C1 8.55699 1.19699 8.36 1.44 8.36H4.08C4.32301 8.36 4.52 8.55699 4.52 8.8C4.52 9.043 4.32301 9.24 4.08 9.24H1.44C1.19699 9.24 1 9.043 1 8.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 8.8C23 8.55699 22.803 8.36 22.56 8.36H19.92C19.677 8.36 19.48 8.55699 19.48 8.8C19.48 9.043 19.677 9.24 19.92 9.24H22.56C22.803 9.24 23 9.043 23 8.8Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.58981 12.6349C6.00051 10.2557 6.20585 9.06609 6.89716 8.25955C7.12582 7.99279 7.38908 7.76136 7.67917 7.57213C8.55621 7 9.70414 7 12 7C14.2959 7 15.4438 7 16.3208 7.57213C16.6109 7.76136 16.8742 7.99279 17.1028 8.25955C17.7941 9.06609 17.9995 10.2557 18.4102 12.6349L19.25 17.5H4.75L5.58981 12.6349ZM3 20.375C3 19.4911 3 19.0492 3.2636 18.7746C3.52721 18.5 3.95147 18.5 4.8 18.5H19.2C20.0485 18.5 20.4728 18.5 20.7364 18.7746C21 19.0492 21 19.4911 21 20.375C21 21.2589 21 21.7008 20.7364 21.9754C20.4728 22.25 20.0485 22.25 19.2 22.25H4.8C3.95147 22.25 3.52721 22.25 3.2636 21.9754C3 21.7008 3 21.2589 3 20.375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiren);
export default __webpack_public_path__ + "static/media/siren.09a0b6a38113e87a8142fe04ce17479f.svg";
export { ForwardRef as ReactComponent };